export default __webpack_public_path__ + "static/media/TermsCondition.f6d72bc0.txt";